/* Language helpers for customer messages in the communication tunnel. */

const LANGUAGE_NAMES = {
  de: 'German', en: 'English', fr: 'French', it: 'Italian', es: 'Spanish', pt: 'Portuguese', nl: 'Dutch',
  sq: 'Albanian', tr: 'Turkish', ar: 'Arabic', sr: 'Serbian', hr: 'Croatian', pl: 'Polish',
};

export const languageName = (code) => {
  const key = String(code || '').toLowerCase().split(/[-_]/)[0];
  return LANGUAGE_NAMES[key] || (key ? key.toUpperCase() : 'the customer language');
};

// Where the delivery language comes from (backend customer_language_source).
export const LANGUAGE_SOURCE_TEXT = {
  actor: 'Language from the contact.',
  last_known: 'Last known language of this contact.',
  detected: 'Detected from the customer\'s messages.',
  default: 'No language known yet, German is used.',
};

/** Template name of an older "[WhatsApp-Vorlage: name]" bot message, or null. */
export const templatePlaceholderName = (content) => {
  const match = /^\s*\[WhatsApp-Vorlage:\s*([\w-]+)\s*\]\s*$/.exec(String(content || ''));
  return match ? match[1] : null;
};

/**
 * The agent's own wording of a reply that was translated before sending,
 * when it was written in `accountLanguage`. Null when the reply was not
 * translated or was written in another language.
 */
export const ownTranslatedText = (msg, accountLanguage) => {
  const meta = msg?.message_metadata || {};
  if (String(msg?.direction || '').toUpperCase() !== 'OUTBOUND') return null;
  if (!meta.authored_text || meta.authored_text === msg.content) return null;
  if (meta.author_language && accountLanguage && meta.author_language !== accountLanguage) return null;
  return meta.authored_text;
};
